import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { SortEnum } from 'utils/enums';
import SortFilter from '../SortFilter';
import { reloadByUpdatingSort } from '../../modules/resultList';

// ---
// Connect to store.
// ---
const mapStateToProps = (state: any) => ({
  initialSortValue: get(state, 'resultList.searchQuery.sort', SortEnum.default),
});

const mapDispatchToProps = (_, { history }: any) => ({
  reloadByUpdatingSort: (sort: any) => reloadByUpdatingSort(history)(sort),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SortFilter),
);
